import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState, userLoggedOut } from 'store/auth/userSlice'
import { apiLogIn, apiLogOut } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import { useNavigate } from 'react-router-dom'
import { Success } from 'utils/alerts'
import { setCompany, setCustomer } from 'store/filterdata/filterDataSlice'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const {
        token,
        // refreshToken,
        signedIn,
    } = useSelector(state => state.auth.session)
    const user = useSelector(state => state.auth.user)
    const { permissionList } = useSelector(state => state.listData)

    const signIn = async values => {
        try {
            const resp = await apiLogIn(values)
            if (resp.data) {
                if (resp.data?.mfa_type) {
                    dispatch(
                        setUser({
                            avatar: '',
                            first_name: '',
                            last_name: '',
                            userName: '',
                            email: resp.data?.user,
                        })
                    )
                    return {
                        status: 'verify',
                        message: 'verify with your email OTP',
                    }
                }
                const { access, refresh } = resp.data?.token
                dispatch(onSignInSuccess({ token: access, refreshToken: refresh }))
                dispatch(setCompany(resp.data?.company_id ? resp.data?.company_id : ''))
                dispatch(setCustomer(resp.data?.customer_id ? resp.data?.customer_id : ''))
                if (resp.data) {
                    resp.data.user = {
                        id: resp.data?.user_id,
                        email: resp.data?.email || values?.email,
                        first_name: resp.data?.first_name,
                        last_name: resp.data?.last_name,
                        role: resp.data?.role,
                        super_user: resp.data?.super_user,
                        company: resp.data?.company_id,
                        customer: resp.data?.customer_id,
                    }

                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                first_name: 'User',
                                last_name: '',
                                userName: 'user@123',
                                email: 'user@gmail.com',
                            }
                        )
                    )
                }
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.detail || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(userLoggedOut(initialState))
        navigate('/login')
    }

    const signOut = async () => {
        // apiLogOut({ refresh_token: refreshToken })
        apiLogOut()
            .then(() => {
                Success('Logout successfully!')
                handleSignOut()
            })
            .catch(error => console.log('Error: ', error))
    }

    const checkPermission = (module, action) => {
        if (user?.super_user) return true
        let permissionsData = []
        let status = false
        if (user?.role && permissionList) {
            user?.role?.permissions.forEach(item => {
                const permission = Object.keys(permissionList)
                    .map((key, index) => permissionList[key].find(permission => permission.id === item.id))
                    .filter(item => item)
                if (permission) {
                    permissionsData.push(permission[0])
                }
            })
        }
        permissionsData?.map(item => {
            if (action) {
                if (module === item?.module && action === item?.action) {
                    status = true
                }
            } else {
                if (module === item?.module) {
                    status = true
                }
            }
            return item
        })
        return status
    }

    return {
        authenticated: token && signedIn,
        signIn,
        signOut,
        checkPermission,
    }
}

export default useAuth
